<label class="checkbox" for={id}>
  <input
    type="checkbox"
    {name}
    {id}
    class="checkbox-input"
    on:change={toggleCheck} />
  <div class="checkbox-view" for={id} />
  <slot />
</label>


<script>
import { createEventDispatcher } from "svelte/internal";
import { pathOr } from "ramda";
export let id;
export let name;
const dispatch = createEventDispatcher();
function toggleCheck(e) {
    const value = pathOr(false, ["target", "value"], e);
    dispatch("toggle", { value });
}
</script>


<style>.checkbox{position:relative;line-height:1rem;vertical-align:middle;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;display:flex;align-items:center}.checkbox-input{position:absolute;opacity:0;top:0;left:0;visibility:hidden;pointer-events:none}.checkbox-input:checked+.checkbox-view:before{display:block}.checkbox-view{display:inline-block;width:1.5rem;height:1.5rem;border:1px solid #9e9e9e;vertical-align:middle;margin-right:.5rem;position:relative;border-radius:4px;align-items:center}.checkbox-view:before{content:"";width:80%;height:45%;position:absolute;top:3px;left:2px;border-color:transparent transparent #f08403 #f08403;border-style:solid;border-width:3px;transform:rotate(-45deg);display:none}</style>
